import { QRVideo } from "./qr-video";
export { QRVideo };
